<template>
  <div :style="style.container">
    <div :style="style.innerContainer">
      <UserImage
        :src="src"
        :style="style.userImage"
      />
      <template v-if="isMyself">
        <ButtonTextSecondary
          :style="style.uploadImageButton"
          @click="openModalToUploadUserImage"
        >
          Update photo
        </ButtonTextSecondary>
      </template>
    </div>
  </div>
</template>

<script>
  import ButtonTextSecondary from '@modules/button/button-text-secondary'
  import UserImage from '@modules/image/user-image'
  import { Layout } from '@js/styles'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'UserHeader',
    components: {
      ButtonTextSecondary,
      UserImage,
    },
    props: {
      isMyself: {
        type: Boolean,
        required: false,
        default: false
      },
      tenantUser: {
        type: Object,
        required: false,
        default: () => {}
      },
    },
    data: function () {
      return {
        style: {
          container: {
            backgroundImage: `url(${require('@img/default-user-cover-001.jpg')})`,
            height: '160px',
            width: '100%',
          },
          innerContainer: {
            margin: 'auto',
            maxWidth: Layout.container.md.maxWidth,
            padding: Layout.container.md.padding,
            position: 'relative',
          },
          uploadImageButton: {
            position: 'absolute',
            top: '192px',
            left: '24px',
          },
          userImage: {
            height: '96px',
            maxHeight: '96px',
            maxWidth: '96px',
            position: 'absolute',
            top: '80px',
            width: '96px',
          },
        },
      };
    },
    computed: {
      src: function () {
        return this.tenantUser.user ? this.tenantUser.user.image : require('@img/user.svg');
      },
    },
    methods: {
      openModalToUploadUserImage: function () {
        if (this.isMyself) {
          this.$modal.show(MODAL_WINDOW_NAMES.UPLOAD_USER_IMAGE_PRIMARY);
        }
      },
    },
  };
</script>
